<ee-responsive-image [images]="images" (clicked)="onClicked()"></ee-responsive-image> 